import React from 'react';
import { usePageTitle } from '../hooks/usePageTitle';
import PublicHeader from '../components/Layout/PublicHeader';
import StaticPageTopbar from '../components/Layout/StaticPageTopbar';

const H3: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <h3 style={{ fontSize: 16, fontWeight: 600, marginBottom: 8, marginTop: 20 }}>{children}</h3>
);

const P: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <p style={{ marginBottom: 12, color: 'var(--text-secondary)' }}>{children}</p>
);

const Datenschutz: React.FC = () => {
  usePageTitle('Datenschutz');

  return (
    <div className="has-bottom-nav" style={{ minHeight: '100vh', background: '#F5F3F3', display: 'flex', flexDirection: 'column' }}>
      <div className="hide-mobile">
        <PublicHeader />
      </div>
      <StaticPageTopbar label="// DATENSCHUTZ" />

      <div style={{ flex: 1, width: '100%', boxSizing: 'border-box', padding: 16, maxWidth: 640, margin: '0 auto' }}>
        <h1 style={{
          fontFamily: "'Archivo',sans-serif", fontWeight: 800, fontSize: 26,
          letterSpacing: '-0.015em', color: '#2C2C2C', margin: '8px 0 16px',
        }}>Datenschutzerklärung</h1>
        <div className="surface-card" style={{ padding: 24, borderRadius: 16 }}>
          <div style={{ color: 'var(--text-primary)', fontSize: 14, lineHeight: 1.7 }}>
            <H3>1. Verantwortlicher</H3>
            <P>
              Verantwortlicher im Sinne der DSGVO ist der im Impressum genannte Betreiber
              (GSK-IT UG (haftungsbeschränkt), Siemensstr. 3, 30916 Isernhagen). Sie erreichen uns
              für alle Datenschutzanliegen unter der im Impressum angegebenen E-Mail-Adresse.
            </P>

            <H3>2. Hosting und Server-Logfiles</H3>
            <P>
              Diese Website wird bei der Hetzner Online GmbH (Industriestr. 25, 91710 Gunzenhausen,
              Deutschland) gehostet. Mit Hetzner besteht ein Vertrag zur Auftragsverarbeitung
              (Art. 28 DSGVO); alle Daten werden in Rechenzentren in Deutschland verarbeitet.
              Beim Aufruf der Website werden automatisch technische Zugriffsdaten verarbeitet
              (IP-Adresse, Datum und Uhrzeit, aufgerufene Seite, User-Agent), soweit dies für die
              Auslieferung der Seite und die Betriebs- und Angriffssicherheit erforderlich ist
              (Art. 6 Abs. 1 lit. f DSGVO). Schriftarten, Skripte und Stylesheets werden von
              unseren eigenen Servern geladen; es werden keine Fonts oder Bibliotheken von
              Drittanbietern (z. B. Google Fonts oder CDNs) eingebunden. An welchen Stellen
              Inhalte anderer Anbieter erscheinen, steht in Abschnitt 13.
            </P>

            <H3>3. Registrierung und Benutzerkonto</H3>
            <P>
              Ein Benutzerkonto entsteht, indem Sie Ihre E-Mail-Adresse angeben und den einmaligen
              Code eingeben, den wir Ihnen daraufhin zusenden. Der Code belegt, dass die Adresse
              Ihnen gehört; gibt es zu ihr noch kein Konto, legen wir dabei eines an. Das gilt für
              jeden Weg, der einen solchen Code verwendet: Anmeldung und Registrierung, das Bestellen
              der Event-Mails, „Benachrichtige mich“ an einem Event und den Zugang für Veranstalter.
              Wir speichern dazu Ihre E-Mail-Adresse und einen automatisch vergebenen Benutzernamen,
              optional Vorname und Nachname. Entsteht das Konto über „Benachrichtige mich“, vermerken
              wir, an welchem Event. Codes werden nur als Hash gespeichert, sind zehn Minuten gültig
              und werden nach Verwendung entwertet. Konten, die mit einem Passwort angelegt wurden,
              speichern dieses ausschließlich als kryptographischen Hash (bcrypt). Optional können
              Sie einen Standort (PLZ/Ort) angeben, um Entfernungen zu Events zu berechnen. Haben Sie
              noch keine Region (Bundesland) gewählt, leiten wir sie aus der Postleitzahl ab; im
              Profil können Sie sie ändern oder löschen.
              Rechtsgrundlage ist die Vertragserfüllung (Art. 6 Abs. 1 lit. b DSGVO). Ebenfalls
              freiwillig können Sie Ihr Geburtsjahr und die Radarten angeben, die Sie fahren. Diese
              Angaben werten wir nur zusammengefasst aus, nie für ein einzelnes Konto; Sie können
              sie im Profil jederzeit ändern oder löschen (Art. 6 Abs. 1 lit. a DSGVO).
            </P>
            <P>
              <strong>Winterchallenge.</strong> Wer bei der Winterchallenge mitmacht, gibt einen
              Anzeigenamen und seine Region an; die Region speichern wir am Konto, sie steht danach
              im Profil. Anzeigename, Region, Team und die eingetragenen Kilometer erscheinen in den
              öffentlichen Ranglisten und auf der Teamseite; das ist Teil der Teilnahme, und darauf
              weisen wir beim Mitmachen hin (Art. 6 Abs. 1 lit. b DSGVO). Wer nicht mehr in den
              Ranglisten stehen möchte, schreibt uns, dann nehmen wir die Teilnahme heraus. Zu jeder
              Fahrt speichern wir Datum,
              Kilometer, Radart und, wenn Sie ihn angeben, einen Link zur Aktivität (etwa bei Strava
              oder Garmin). Diesen Link sieht nur unsere Redaktion, wenn eine Fahrt geprüft werden
              muss; er erscheint nicht öffentlich. Meldet jemand einen Teilnehmer, speichern wir, wer
              gemeldet hat. Mit dem Konto löschen wir Teilnahme, Fahrten und Meldungen.
            </P>

            <P>
              <strong>Community und Eventplanung.</strong> Die Community ist freiwillig. Wir verwenden
              Ihren vorhandenen Vor- und Nachnamen, ersatzweise den Benutzernamen. Die Auffindbarkeit
              über Ihren vollständigen Benutzernamen ist standardmäßig aktiviert. Wenn Sie die
              Auffindbarkeit bereits ausgeschaltet haben, bleibt sie ausgeschaltet. Andere angemeldete
              Nutzer können Sie finden, wenn sie Ihren Benutzernamen genau kennen; eine Suche nach
              Namen oder Teilen davon gibt es nicht. Die Auffindbarkeit können Sie in der
              Freundeverwaltung abschalten. Ihr Einladungslink funktioniert unabhängig davon.
              Wer Ihren persönlichen Einladungslink annimmt, wird ohne weitere Bestätigung zu Ihrer
              Freundesliste hinzugefügt. Die Einladungsseite ist auch ohne Anmeldung sichtbar und
              kann über einen weitergeleiteten Link aufgerufen werden. Sie zeigt den ersten Teil
              Ihres hinterlegten Namens beziehungsweise Benutzernamens. Sie können den Einladungslink
              jederzeit erneuern; der bisherige Link wird dadurch ungültig. Bestehende Freundschaften
              bleiben erhalten. Wenn jemand Ihre Einladung annimmt, benachrichtigen wir Sie per
              E-Mail und, sofern Sie Push-Benachrichtigungen aktiviert haben, per Push-Nachricht.
              Schickt Ihnen jemand eine Freundschaftsanfrage, informieren wir Sie per E-Mail mit dem
              Vornamen der anfragenden Person; das können Sie unter „Benachrichtigungen“ abschalten.
              Wir speichern Freundschaftsanfragen, bestätigte
              Verbindungen und Blockierungen. Bestätigte Freunde sehen Ihren Kontonamen bei den
              Events, die Sie über das Lesezeichen vorgemerkt haben, und bei den Events, für die
              Sie „Ich bin dabei“ gewählt haben, jeweils mit der Angabe, ob Sie vorgemerkt oder
              zugesagt haben. Andere Nutzer sehen das nicht. Die Zusage ist keine bestätigte
              Buchung beim Veranstalter. Sie können Vormerkung und Zusage jederzeit
              zurücknehmen und Freundschaften entfernen oder
              blockieren. E-Mail-Adresse, Standort und weitere private Kontoangaben erscheinen dabei nicht für
              andere Nutzer. Mit dem Konto löschen wir auch Ihre Community-Einstellungen, Ihre
              Verbindungen, Blockierungen und Eventplanungen.
            </P>

            <H3>4. E-Mail-Versand und Benachrichtigungen</H3>
            <P>
              System-E-Mails (z. B. Registrierungsbestätigung, Anmeldecodes, Antworten auf
              Anfragen) versenden wir über die IONOS SE (Elgendorfer Str. 57, 56410 Montabaur,
              Deutschland) als Auftragsverarbeiter; die Verarbeitung erfolgt in Deutschland.
              Registrierte Nutzer können optional E-Mail-Benachrichtigungen aktivieren
              (z. B. eine wöchentliche Event-Übersicht oder Hinweise auf neu eingetragene Events
              in ihrer Region) oder mit „Benachrichtige mich“ an einem Event eine Nachricht zu
              dessen Anmeldung bestellen. Diese Benachrichtigungen sind standardmäßig deaktiviert,
              werden nur auf Ihre Bestellung hin verschickt und können jederzeit in den
              Profileinstellungen oder über den Link in jeder Mail abgeschaltet werden (Art. 6
              Abs. 1 lit. a DSGVO). An registrierte Nutzer mit bestätigter Adresse verschicken wir
              außerdem gelegentlich, etwa einmal im Monat, eine Rundmail mit Neuigkeiten zu
              Radsport Events (neue Funktionen, Aktionen wie die Winterchallenge). Dem können Sie
              jederzeit widersprechen, über den Link in jeder Rundmail oder den Schalter
              „Neuigkeiten“ in den Profileinstellungen, ohne dass dafür andere als die
              Übermittlungskosten nach den Basistarifen entstehen (Art. 6 Abs. 1 lit. f DSGVO,
              § 7 Abs. 3 UWG). Zur Fehlerdiagnose und zum Schutz vor Fehlversand führen wir ein internes
              Versandprotokoll (Empfänger, Betreff, Inhalt, Zustellstatus), das nach 90 Tagen
              automatisch gelöscht wird (Art. 6 Abs. 1 lit. f DSGVO).
            </P>

            <H3>5. Event-Vorschläge</H3>
            <P>
              Beim Einreichen oder Korrigieren von Events (auch ohne Konto möglich) können Sie
              freiwillig Ihren Namen und Ihre E-Mail-Adresse für Rückfragen angeben. Diese Angaben
              werden zusammen mit dem Vorschlag gespeichert und nur zur Bearbeitung des Vorschlags
              verwendet (Art. 6 Abs. 1 lit. b und f DSGVO).
            </P>

            <H3>6. Feedback</H3>
            <P>
              Über das Feedback-Widget können Sie uns anonym eine Bewertung und einen Kommentar
              senden. Optional können Sie eine E-Mail-Adresse für Rückfragen angeben; sie ist
              freiwillig und wird ausschließlich zur Kontaktaufnahme zu Ihrem Feedback verwendet
              (Art. 6 Abs. 1 lit. a DSGVO, Widerruf jederzeit per E-Mail an uns).
            </P>

            <H3>7. Kontakt- und Partner-Anfragen</H3>
            <P>
              Über das Kontaktformular auf der Seite „Kontakt" sowie über das Kontaktformular für
              Partner erheben wir Name, E-Mail-Adresse, optional Verein oder Firma, das gewählte
              Thema und Ihre Nachricht. Die Daten werden zur Bearbeitung Ihrer Anfrage gespeichert
              (Art. 6 Abs. 1 lit. b bzw. lit. f DSGVO — bei Partner-Anfragen zur Anbahnung einer
              Zusammenarbeit, sonst aufgrund unseres berechtigten Interesses an der Beantwortung).
            </P>
            <P>
              Optional können Sie Ihrer Anfrage bis zu drei Dateien beifügen (Bilder oder PDF,
              etwa einen Screenshot zu einem gemeldeten Fehler). Diese Dateien speichern wir
              zusammen mit der Anfrage; sie werden <strong>nicht öffentlich zugänglich gemacht</strong> und
              sind ausschließlich für Redaktion und Administration abrufbar. Bitte senden Sie uns
              keine Dateien mit besonderen Kategorien personenbezogener Daten (Art. 9 DSGVO).
            </P>
            <P>
              Die Anfragen werden nicht per E-Mail weitergeleitet, sondern ausschließlich in
              unserem eigenen System gespeichert und dort von Redaktion und Administration
              bearbeitet. Antworten wir Ihnen per E-Mail, gelten für diese Korrespondenz die
              Angaben in Abschnitt 4.
            </P>

            <H3>8. Webanalyse (Umami)</H3>
            <P>
              Wir verwenden Umami, ein datenschutzfreundliches Open-Source-Analysetool, das auf
              unserem eigenen Server in Deutschland betrieben wird. Umami verwendet keine Cookies
              und speichert keine personenbezogenen Daten; erhoben werden ausschließlich
              anonymisierte bzw. aggregierte Informationen (Seitenaufrufe, Referrer, Gerätetyp,
              Browsertyp). Rechtsgrundlage ist unser berechtigtes Interesse an der
              Reichweitenmessung (Art. 6 Abs. 1 lit. f DSGVO).
            </P>

            <H3>9. Reichweitenmessung für Inhalte und Werbepartner</H3>
            <P>
              Um Aufrufe und Klicks auf Inhalte und Werbebanner zu zählen, verwenden wir ein
              eigenes, cookieloses Verfahren: Aus IP-Adresse und Browserkennung wird zusammen mit
              einem geheimen, täglich wechselnden Schlüssel ein pseudonymer Tageswert (Hash)
              berechnet. IP-Adresse und Browserkennung selbst werden dabei nicht gespeichert; eine
              Rückführung auf Ihre Person oder eine seitenübergreifende Profilbildung ist nicht
              möglich. Rechtsgrundlage ist unser berechtigtes Interesse an der Messung und
              Abrechnung von Werbeleistungen (Art. 6 Abs. 1 lit. f DSGVO).
            </P>

            <H3>10. Partnerlinks</H3>
            <P>
              Einzelne Verweise auf unseren Seiten und in unserer App sind Partnerlinks
              (Affiliate-Links); sie sind jeweils als „Partnerlink" gekennzeichnet. Klicken Sie
              darauf, werden Sie über ein Partnernetzwerk zum jeweiligen Anbieter weitergeleitet.
              Dabei übermittelt Ihr Browser die üblichen Verbindungsdaten (insbesondere
              IP-Adresse, Datum und Uhrzeit sowie die aufgerufene Adresse) an das Netzwerk und den
              Anbieter, und dort wird ein Cookie gesetzt, über das ein anschließender Kauf oder
              eine Buchung uns zugeordnet und vergütet wird. Von den Anbietern erhalten wir keine
              personenbezogenen Daten, sondern ausschließlich zusammengefasste Abrechnungsdaten.
            </P>
            <P>
              Diese Übermittlung findet erst statt, wenn Sie einen solchen Link aktiv anklicken;
              auf unserer Seite selbst wird dafür nichts auf Ihrem Endgerät gespeichert oder
              ausgelesen. Rechtsgrundlage ist unser berechtigtes Interesse an der Finanzierung des
              Angebots (Art. 6 Abs. 1 lit. f DSGVO). Je nach Anbieter kann dabei eine Übermittlung
              in ein Drittland, insbesondere die USA, stattfinden. Welche Daten die beteiligten
              Unternehmen anschließend verarbeiten, entzieht sich unserem Einfluss.
            </P>
            <P>
              Derzeit nutzen wir das Partnerprogramm von Booking.com (Booking.com B.V., Amsterdam,
              Niederlande) über das Netzwerk CJ Affiliate (Commission Junction LLC, USA).
              Einzelheiten finden Sie in deren Datenschutzhinweisen unter{' '}
              <a href="https://www.cj.com/legal/privacy" target="_blank" rel="noopener noreferrer"
                style={{ color: '#922C57' }}>cj.com/legal/privacy</a>{' '}und{' '}
              <a href="https://www.booking.com/content/privacy.de.html" target="_blank" rel="noopener noreferrer"
                style={{ color: '#922C57' }}>booking.com/content/privacy.de.html</a>.
            </P>

            <H3>11. Cookies und lokale Speicherung</H3>
            <P>
              Wir verwenden keine Tracking-Cookies. Zur Authentifizierung wird ein Anmelde-Token
              im lokalen Speicher Ihres Browsers bzw. in der Mobil-App im verschlüsselten
              Gerätespeicher abgelegt. Es wird mit der Abmeldung entfernt. Daneben speichert der
              Browser lokale Einstellungen (z. B. Darstellungsoptionen), die unser Server nicht
              erhält.
            </P>

            <H3>12. Push-Benachrichtigungen (Mobil-App)</H3>
            <P>
              In der Mobil-App können Sie optional Push-Benachrichtigungen aktivieren. Dazu wird
              ein Push-Token Ihres Geräts gespeichert und die Zustellung über den
              Benachrichtigungsdienst von Expo (Expo, Inc., USA) sowie die Dienste des jeweiligen
              Plattformbetreibers (Apple/Google) abgewickelt; dabei kann eine Übermittlung in die
              USA stattfinden, die durch EU-Standardvertragsklauseln bzw. das EU-US Data Privacy
              Framework abgesichert ist. Rechtsgrundlage ist Ihre Einwilligung (Art. 6 Abs. 1
              lit. a DSGVO); Sie können sie jederzeit über die Geräteeinstellungen widerrufen.
            </P>

            <H3>13. Karten, eingebundene Inhalte und Geocoding</H3>
            <P>
              An einigen Stellen lädt Ihr Browser Inhalte direkt von anderen Anbietern. Dabei
              erhält der jeweilige Anbieter Ihre IP-Adresse und die üblichen technischen
              Zugriffsdaten; das geschieht erst, wenn Sie die betreffende Seite oder Funktion
              aufrufen. Rechtsgrundlage ist unser berechtigtes Interesse an einer
              funktionsfähigen Darstellung von Karten, Strecken und Anleitungen
              (Art. 6 Abs. 1 lit. f DSGVO).
            </P>
            <P>
              <strong>Kartenkacheln:</strong> Die Karten der Umkreissuche und der Streckenansicht
              beziehen ihre Kacheln von OpenStreetMap (OpenStreetMap Foundation, Cambridge,
              Vereinigtes Königreich). <strong>Streckenkarten:</strong> Auf Event-Seiten, zu denen
              der Veranstalter eine Komoot-Strecke hinterlegt hat, wird diese als Karte von
              komoot GmbH (Potsdam, Deutschland) eingebettet. <strong>Anleitungen:</strong> Die
              Videos auf der Hilfeseite werden von Loom (Atlassian Pty Ltd, Sydney, Australien)
              geladen; dabei kann eine Übermittlung in ein Drittland stattfinden.{' '}
              <strong>Logos und Flyer:</strong> Bilder, die Veranstalter nicht bei uns
              hochgeladen, sondern per Link angegeben haben, werden von deren eigenen Servern
              geladen. Einzelne Vereinslogos liegen noch in einem Speicherdienst von Google
              (Google Cloud Storage) aus der Zeit vor dem Umzug auf eigene Server; sie werden
              schrittweise auf unsere Server übernommen.
            </P>
            <P>
              <strong>Geocoding:</strong> Zur Berechnung von Event-Koordinaten verwenden wir
              serverseitig den Dienst OpenStreetMap Nominatim. Dabei werden ausschließlich
              Veranstaltungsadressen übermittelt, keine personenbezogenen Daten unserer Nutzer.
            </P>

            <H3>14. Weitergabe von Daten</H3>
            <P>
              Ihre Daten werden nur an die oben genannten Auftragsverarbeiter (Hetzner, IONOS,
              bei App-Push: Expo/Apple/Google) weitergegeben, soweit dies für den jeweiligen Zweck
              erforderlich ist. Eine darüber hinausgehende Weitergabe an Dritte erfolgt nicht, es
              sei denn, wir sind gesetzlich dazu verpflichtet. Unberührt bleibt die in
              Abschnitt 10 beschriebene Weiterleitung über Partnerlinks, die Sie selbst auslösen.
            </P>

            <H3>15. Speicherdauer</H3>
            <P>
              Kontodaten speichern wir, solange Ihr Konto besteht. Das E-Mail-Versandprotokoll wird
              nach 90 Tagen automatisch gelöscht. Feedback, Event-Vorschläge sowie Kontakt- und
              Partner-Anfragen
              speichern wir, solange es für die Bearbeitung bzw. Nachvollziehbarkeit erforderlich
              ist. Messdaten der Reichweitenmessung liegen nur pseudonymisiert bzw. aggregiert vor.
              Darüber hinaus speichern wir Daten nur, soweit gesetzliche Aufbewahrungspflichten
              bestehen.
            </P>

            <H3>16. Ihre Rechte</H3>
            <P>
              Sie haben das Recht auf Auskunft (Art. 15 DSGVO), Berichtigung (Art. 16),
              Löschung (Art. 17), Einschränkung der Verarbeitung (Art. 18) und
              Datenübertragbarkeit (Art. 20). Verarbeitungen auf Grundlage berechtigter Interessen
              können Sie nach Art. 21 DSGVO widersprechen; erteilte Einwilligungen können Sie
              jederzeit mit Wirkung für die Zukunft widerrufen. Kontaktieren Sie uns hierzu über
              die im Impressum angegebene E-Mail-Adresse. Außerdem haben Sie das Recht, sich bei
              einer Datenschutz-Aufsichtsbehörde zu beschweren (Art. 77 DSGVO) — für uns zuständig
              ist die Landesbeauftragte für den Datenschutz Niedersachsen.
            </P>

            <H3>17. Verschlüsselung</H3>
            <P>
              Die Übertragung aller Daten zwischen Ihrem Gerät und unseren Servern erfolgt
              ausschließlich TLS-verschlüsselt (HTTPS).
            </P>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Datenschutz;
